import useSWR from "swr";
import { DynamicPriceRate } from "../../data";

interface UseBulkHourlyDiscountQueryReturn {
  data:
    | {
        featuredDynamicPriceRate: DynamicPriceRate;
      }
    | undefined;
}

export function useBulkHourlyDiscountQuery(
  offeringId: string
): UseBulkHourlyDiscountQueryReturn {
  const { data } = useSWR(
    `/api/v2/partner_offerings/${offeringId}/bulk_hourly_discount`
  );

  return { data: data ? toBulkHourlyDiscount(data) : undefined };
}

function toBulkHourlyDiscount(data: any) {
  const { featured_dynamic_price_rate } = data;

  if (featured_dynamic_price_rate) {
    return {
      featuredDynamicPriceRate: {
        dynamicPriceFormula: {
          adjustmentType:
            featured_dynamic_price_rate.dynamic_price_formula?.adjustment_type,
          adjustmentValue: Math.abs(
            Number(
              featured_dynamic_price_rate.dynamic_price_formula
                ?.adjustment_value
            )
          ),
        },
        bookingCriteria:
          featured_dynamic_price_rate.booking_criteria?.map(toBookingCriteria),
      },
    };
  }
}

function toBookingCriteria(data: any) {
  return {
    minBookingUnit: Number(data.min_booking_unit),
  };
}
